export const HOME = '/';
export const SHOP = '/shop';
export const ACCOUNT = '/account';
export const ACCOUNT_EDIT = '/account/edit';
export const ADMIN_DASHBOARD = '/admin/dashboard';
export const ADMIN_PRODUCTS = '/admin/products';
export const ADMIN_PRODUCTS_ADD = '/admin/add/product';
export const ADMIN_PRODUCTS_EDIT = '/admin/edit/product';
export const ADMIN_USERS = '/admin/users';
export const ADMIN_COMPANIES = '/admin/companies';
export const ADMIN_IMAGES = '/admin/images';
export const ADMIN_BRANDS = '/admin/brands';
export const ADMIN_ADS = '/admin/ads';
export const ADMIN_PLANS = '/admin/plans';
export const ADMIN_PAYMENTS = '/admin/payments';
export const ADD_PRODUCT = '/add';
export const EDIT_PRODUCT = '/edit';
export const SIGNIN = '/signin';
export const SIGNOUT = '/signout';
export const SIGNUP = '/signup';
export const FORGOT_PASSWORD = '/forgot_password';
export const VIEW_PRODUCT = '/product/:id';
export const MESSAGES = '/messages';
export const VIEW_MESSAGE = '/message/:id';
export const PRICING = '/pricing';
